import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { ActionCounts, PriorityBadge, StatusBadge } from './rowBadges';

import { formatDateWithYear } from 'Helpers/dateTimeService';

/**
 * The user's decisions.
 *
 * The issue table with one column swapped: Decision Date, which is when the
 * decision was or is to be taken. It is NOT the date the overdue flag reads —
 * that is the decision's target date, which the register keeps separate and so
 * does the row.
 */
export default function DecisionSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-32">{$t('Status')}</th>
                        <th className="tw-w-28">{$t('Priority')}</th>
                        <th className="tw-w-36">{$t('Decision Date')}</th>
                        <th className="tw-w-24">{$t('Actions (Outstanding)')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: row.overdue })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.description })}>
                                    {row.description}
                                </OpenRowButton>
                            </td>
                            <td>
                                <StatusBadge status={row.status} />
                            </td>
                            <td>
                                <PriorityBadge priority={row.priority} />
                            </td>
                            <td className="inbud-date-cell">{orNotSet(row.decision_date && formatDateWithYear(row.decision_date))}</td>
                            <td className="inbud-numeric-cell">
                                <ActionCounts total={row.actions_total} outstanding={row.actions_outstanding} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
